<div class="modal-header" id="customer-modal-title">
    <h3 class="modal-title" id="modal-title" translate="NOTIFICATION_DETAILS_ADDRESS_INFO_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="col-4">
            <strong translate="NOTIFICATION_DETAILS_ADDRESS_INFO_ADDRESS_LABEL"></strong>
        </div>
        <div class="col-8">
            <p>
                {{ notification.address.completeName }}<br />
                {{ notification.address.street.value }}<br />
                {{ notification.address.postCode.value }} <br />
                {{ notification.address.city.value }}
                @if (notification.address.statesOfUSA?.selectedEntry?.model?.value; as selectedState) {
                    ; {{ selectedState }}
                }
            </p>
            <div class="cursor-pointer" (click)="showMap()">
                <span><fa-icon class="me-1" [icon]="faMapMarker"></fa-icon></span>
                <strong translate="NOTIFICATION_DETAILS_ADDRESS_INFO_VIEW_MAPS_LABEL"></strong>
            </div>
        </div>
    </div>
    <hr />
    <div class="row">
        <div class="col-4">
            <strong translate="NOTIFICATION_DETAILS_ADDRESS_INFO_TEL_LABEL"></strong>
        </div>
        <div class="col-8">
            <p>{{ notification.address.phone.value }}</p>
        </div>
    </div>
    <hr />
    @if (notification.address.fax1.value) {
        <div class="row">
            <div class="col-4">
                <strong translate="NOTIFICATION_DETAILS_ADDRESS_INFO_EMAIL_LABEL"></strong>
            </div>
            <div class="cursor-pointer" (click)="openEmail(notification.address.fax1.value)" class="col-8">
                <p>
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                    {{ notification.address.fax1.value }}
                </p>
            </div>
        </div>
    }
    @if (notification.address.fax2.value) {
        <div class="row">
            <div class="col-4">
                <strong translate="NOTIFICATION_DETAILS_ADDRESS_INFO_EMAIL_LABEL"></strong>
            </div>
            <div class="cursor-pointer" (click)="openEmail(notification.address.fax2.value)" class="col-8">
                <p>
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                    {{ notification.address.fax2.value }}
                </p>
            </div>
        </div>
    }
    @if (notification.address.fax3 && notification.address.fax3.value) {
        <div class="row">
            <div class="col-4">
                <strong translate="NOTIFICATION_DETAILS_ADDRESS_INFO_EMAIL_LABEL"></strong>
            </div>
            <div class="cursor-pointer" (click)="openEmail(notification.address.fax3.value)" class="col-8">
                <p>
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                    {{ notification.address.fax3.value }}
                </p>
            </div>
        </div>
    }
    @if (notification.address.fax4 && notification.address.fax4.value) {
        <div class="row">
            <div class="col-4">
                <strong translate="NOTIFICATION_DETAILS_ADDRESS_INFO_EMAIL_LABEL"></strong>
            </div>
            <div class="cursor-pointer" (click)="openEmail(notification.address.fax4.value)" class="col-8">
                <p>
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                    {{ notification.address.fax4.value }}
                </p>
            </div>
        </div>
    }
    @if (
        notification.address.fax1.value ||
        notification.address.fax2.value ||
        (notification.address.fax3 && notification.address.fax3.value) ||
        (notification.address.fax4 && notification.address.fax4.value)
    ) {
        <hr />
    }
    <div class="row">
        <div class="col-4">
            <strong translate="NOTIFICATION_DETAILS_ADDRESS_INFO_REPORTEDBY_LABEL"></strong>
        </div>
        <div class="col-8">
            <p>{{ notification.notificationText }}</p>
        </div>
    </div>
    <hr />
    <div class="row">
        <div class="col-4">
            <strong translate="NOTIFICATION_DETAILS_ADDRESS_INFO_DISPATCHER_LABEL"></strong>
        </div>
        <div class="col-8">
            <p>{{ notification.dispatcher }}</p>
        </div>
    </div>
</div>
